module.exports = __webpack_public_path__ + "Bliss2-MediumItalic.6bc59f04857a50c7cf79.woff2";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-MediumItalic.woff2
// module id = ../../../../../src/assets/layout/fonts/Bliss2-MediumItalic.woff2
// module chunks = styles